module.exports = __webpack_public_path__ + "assets/44eedaecad885539080a310924fbfec0.png";